/**
 * Removes diacritics from a string via NFD normalization + combining-mark strip.
 * Safe to run before slugify() — fills gaps in slugify's charmap
 * (e.g. Ĺ/ĺ U+0139/U+013A are silently dropped by slugify@1.6.9).
 */
export function removeDiacritics(value: string): string {
	return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
